
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2216|2482|5080|5709)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
